import React from 'react'
import { List, ListItem } from '@mui/material'
import { withStyles } from 'tss-react/mui'
import styles from './DeviceCardList.style'

import DeviceCard from './DeviceCard'

interface Props {
  classes: Record<string, string>,
  resetMode: boolean,
  devices: any[],
  devicesForReset?: number[],
  addDeviceToResetArray: (id: number) => void,
  deleteDeviceFromResetArray: (id: number) => void,
}

class DeviceCardsList extends React.PureComponent<Props> {
  static defaultProps = {
    devicesForReset: [],
  }

  render() {
    const {
      classes,
      devices,
      resetMode,
      devicesForReset,
      addDeviceToResetArray,
      deleteDeviceFromResetArray,
    } = this.props
    return (
      <List className={classes.root}>
        {devices.map((device: Record<string, any>) => (
          <ListItem className={classes.listItem} key={`${device.id}-${device.sub_id && device.name}`}>
            <DeviceCard
              device={device}
              resetMode={resetMode}
              devicesForReset={devicesForReset}
              addDeviceToResetArray={addDeviceToResetArray}
              deleteDeviceFromResetArray={deleteDeviceFromResetArray}
            />
          </ListItem>
        ))}
      </List>
    )
  }
}

export default withStyles(DeviceCardsList, styles as any) as unknown as React.ComponentType<Omit<Props, 'classes'>>
